import { render, staticRenderFns } from "./AppointmentsRelocationView.vue?vue&type=template&id=479021d2&scoped=true&lang=pug"
import script from "./AppointmentsRelocationView.vue?vue&type=script&lang=js"
export * from "./AppointmentsRelocationView.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsRelocationView.vue?vue&type=style&index=0&id=479021d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479021d2",
  null
  
)

export default component.exports